module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11nDi9m/tc-custom/9780226470986.jpg?1731007752350",
      "alt": "This image is the cover for the book More than Cool Reason"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("More than Cool Reason\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"The authors restore metaphor to our lives by showing us that it's never gone away. We've merely been taught to talk as if it had: as though weather maps were more 'real' than the breath of autumn; as though, for that matter, Reason was really 'cool.' What we're saying whenever we say is a theme this book illumines for anyone attentive.\" — Hugh Kenner, Johns Hopkins University"), _c('br'), _c('br'), _vm._v(" \"In this bold and powerful book, Lakoff and Turner continue their use of metaphor to show how our minds get hold of the world. They have achieved nothing less than a postmodern Understanding Poetry, a new way of reading and teaching that makes poetry again important.\" — Norman Holland, University of Florida")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George Lakoff, Marl Turner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Please fill in author biography")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University Of Chicago Press, Chicago\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0